import {
  ListPspPhasesDto,
  ListPspWorkPackagesDto,
} from '@codefluegel/zeta-change-typescript-client';
import { useEffect, useState } from 'react';
import { usePspPhaseApiFactory } from '../ApiClient';

// Define the shape of your configuration object
interface PspConfig {
  phaseIdKey: string;
  areaIdKey: string;
  workPackageIdKey: string;
}

// TODO FIX TYPE
function usePspLogic(
  currentWorkPackage: any,
  pspPhases: ListPspPhasesDto[],
  config: PspConfig,
) {
  const [currentPspPhase, setCurrentPspPhase] =
    useState<ListPspPhasesDto | null>(null);
  const [currentPspArea, setCurrentPspArea] = useState<string | null>(null);
  const [pspWorkPackages, setPspWorkPackages] = useState<
    ListPspWorkPackagesDto[]
  >([]);

  const defaultPSPAreas = [
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
    '13',
    '14',
  ];
  const [pspAreas, setPspAreas] = useState<string[]>(defaultPSPAreas);
  const pspPhaseApi = usePspPhaseApiFactory();

  // Use the config keys instead of hardcoded names
  const { phaseIdKey, areaIdKey, workPackageIdKey } = config;

  const handleChangePhasePsp = async (phase: ListPspPhasesDto) => {
    setCurrentPspPhase(phase);
    setCurrentPspArea(null);
    setPspWorkPackages([]);

    const { data: areas } =
      await pspPhaseApi.pspPhasesControllerFindAllAreaWorkPackages({
        pspId: phase.id,
      });
    setPspAreas(areas ?? []);
  };

  const handleChangeAreaPsp = async (val: string) => {
    setCurrentPspArea(val);
    if (currentPspPhase?.id) {
      const { data: workPackages } =
        await pspPhaseApi.pspPhasesControllerFindAllPspWorkPackages({
          pspId: currentPspPhase.id,
          areaId: val,
        });
      setPspWorkPackages([...workPackages]);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!currentWorkPackage) return;
      const phase = pspPhases.find(
        p => Number(p.id) === Number(currentWorkPackage[phaseIdKey]),
      );
      if (!phase) return;

      setCurrentPspPhase(phase);
      setCurrentPspArea(String(currentWorkPackage[areaIdKey]));

      try {
        const { data: areas } =
          await pspPhaseApi.pspPhasesControllerFindAllAreaWorkPackages({
            pspId: phase.id,
          });
        setPspAreas(areas ?? []);

        if (currentWorkPackage[areaIdKey]) {
          const areaPspStr = String(currentWorkPackage[areaIdKey]).padStart(
            2,
            '0',
          );
          const { data: workPackages } =
            await pspPhaseApi.pspPhasesControllerFindAllPspWorkPackages({
              pspId: phase.id,
              areaId: areaPspStr,
            });
          setPspWorkPackages(workPackages ?? []);
        }
      } catch (e) {
        console.warn('cannot find combination', e);
      }
    };
    if (pspWorkPackages.length === 0) fetchData();
  }, [
    currentWorkPackage,
    pspPhases,
    pspPhaseApi,
    config,
    workPackageIdKey,
    areaIdKey,
    phaseIdKey,
    pspWorkPackages,
  ]);

  return {
    currentPspPhase,
    currentPspArea,
    pspWorkPackages,
    pspAreas,
    handleChangePhasePsp,
    handleChangeAreaPsp,
  };
}

export default usePspLogic;
